"use client";
import React from "react";
import { useIntl } from "react-intl";

import { useJob } from "../_context/JobContext";

import Collapsable, { CollapsableLoading } from "./collapsable";
import SanitizeAndEscape from "@components/Typo/SanitizeAndEscape";
import { Skeleton } from "@components/ui/skeleton";

const Benefits = () => {
  const { job } = useJob();

  const intl = useIntl();
  const translation: any = intl.messages["job-details"];

  if (!job?.benefits) return null;

  return (
    <Collapsable id="benefits" title={translation["job-benefits"]}>
      <SanitizeAndEscape input={job?.benefits || ""} />
    </Collapsable>
  );
};

export default Benefits;

export const BenefitsLoading = () => {
  return (
    <CollapsableLoading>
      <div className="space-y-2">
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-full h-4" />
      </div>
    </CollapsableLoading>
  );
};
